import navToggle from "../actions/navToggle";

/**
 * header.js
 *
 * Functionality related to the site header
 *
 *
 * @param $ jQuery
 */
const Header = ($) => {
	navToggle($);
};

export default Header;
